<template>
  <div>
        <h2 class="HeaderText">Tournament Gallery</h2>
        <div class="GallerySection">
          <b-row v-if="tournGallaryDataFull.Message == 'Ok'" class="spaceBottom">
            <b-col
              v-for="(item, index) in tournGallaryData"
              :key="'gallery' + index"
              lg="3"
              sm="12"
            >
              <h2 class="headingGallery">{{ item.Name }}</h2>
                <div
                  v-for="gallery in imageGallery"
                  :key="gallery.uri"
                  v-show="item.Uri === gallery.uri"
                >
                  <div
                    v-for="(img, i) in validGalleryImages(gallery)"
                    :key="i"
                  >
                    <b-link :href="img.WebUri.replace(/i-[A-Za-z0-9]+/, '')" target="_blank">
                      <div
                        class="thumbImage"
                        :style="{ backgroundImage: 'url(' + img.ArchivedUri + ')' }"
                      ></div>
                    </b-link>
                  </div>
                </div>

            </b-col>
          </b-row>
            <b-row v-else class="noImages">
                <b-col>
                    <h2 class="headingGallery NoPresent">
                        No Images Available At Present
                    </h2>
                </b-col>
            </b-row>
        </div>
  </div>
</template>

<script>
import axios from 'axios';
import * as CryptoJS from 'crypto-js';
export default {
  name: 'Gallery Section',
  props: ['season', 'code', 'config', 'tournID'],
  components: {
  },
  data: function() {
    const CryptoJSAesJson = {
      'stringify': (cipherParams) => {
        const j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};

        if (cipherParams.iv)
          j.iv = cipherParams.iv.toString();

        if (cipherParams.salt)
          j.s = cipherParams.salt.toString();

        return JSON.stringify(j);
      },
      'parse': (jsonStr) => {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});

        if (j.iv)
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);

        if (j.s)
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);

        return cipherParams;
      },
    };
    return {
        cryptoAES: CryptoJSAesJson,
        tournGallaryData: [],
    //   wholeImages: []
        imageGallery: [],
        tournGallaryDataFull: [] 
    };
  },
  methods: {
    validGalleryImages(gallery) {
      if (!gallery.images) {
        return [];
      }

      return gallery.images
        .filter(img => img && img.ArchivedUri && img.WebUri)
        .slice(0, 1);
    },
    base64Decode(input) {
      const decStr = atob(input);
      const bytes = new Uint8Array(decStr.length);

      for (let i = 0; i < bytes.length; i++)
        bytes[i] = decStr.charCodeAt(i);

      return String.fromCharCode(...new Uint16Array(bytes.buffer));
    },
    hashString(input) {
      return CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
    },
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {

        var tour = ''
        if (this.tournID == 'cpt') {
          tour = 'Tier-1'
        } else if(this.tournID == 'cp2') {
          tour = 'Tier-2'
        }else if(this.tournID == 'cp3') {
          tour = 'Amateur'
        }else if(this.tournID == 'pam') {
          tour = 'Pro-Ams'
        }else if(this.tournID == 'qsc') {
          tour = 'Q-School'
        }

        axios.get(
            'https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' + encodeURIComponent(btoa(process.env.VUE_APP_LONG_SMUG_TOURNAMENT + this.season + '/' + tour +'/' + this.code + '!albumlist' + '?APIKey=' + 'GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2' + '&_accept=application/json'))
        ) // Page number changed on each page based on JSON page id you are calling
        .then(response => {
            this.tournGallaryDataFull = response.data;
            this.tournGallaryData = response.data.Response.AlbumList
            this.imageGallery = []; // reset before loop
            console.log("this.imageGallery")
            console.log(this.imageGallery)
            const requests = this.tournGallaryData.map(value => {
              return axios.get(
                'https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' +
                encodeURIComponent(
                  btoa(
                    process.env.VUE_APP_SMUG_SHORT +
                    value.Uri +
                    '!images' +
                    '?APIKey=' +
                    'GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2' +
                    '&_accept=application/json'
                  )
                )
              ).then(res => {
                return {
                  uri: value.Uri,
                  images: res.data.Response.AlbumImage
                };
              });
            });

            Promise.all(requests).then(results => {
              this.imageGallery = results;
            });
        })
  },
}
</script>

<style scoped>
    .spaceBottom {
      margin-bottom: 40px;
    }
    .noImages {
        background-color: #F8F8F8;   
        height: 200px;
    }
    .NoPresent {
        padding-bottom: 0 !important;
        text-align: center;
        margin-top: 2.4em;
        font-size: 32px !important;
    }
    .thumbImage {
        height: 300px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border-radius: 6px;
        transition: all 0.4s ease;
        /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
        transition: all 350ms cubic-bezier(.37, 0, .63, 1);
    }
    .thumbImage:hover {
        transform: translateY(-10px);
    }
    h2.headingGallery {
        color: #081C3F;
        /* font-weight: 600; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        font-size: 26px;
        padding-bottom: 20px;
    }
    h2.HeaderText {
        color: #081C3F;
        font-size: 36px;
        /* font-weight: bold; */
        padding-bottom: 50px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
    p {
        font-size: 18px;
        color: #081C3F;
    }
    @media only screen and (max-width: 510px) {
        h2.HeaderText {
            padding-top: 20px;
            color: #081C3F;
            font-size: 36px;
            /* font-weight: bold; */
            padding-bottom: 30px;
            font-family: "brown-pro-condensed", sans-serif;
            font-weight: 800;
            font-style: normal;
        }
    }
</style>
